var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgBounce = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    enableBackground: "new 0 0 512 512",
    viewBox: "0 0 512 512",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M501.333 128H394.667c-5.896 0-10.667 4.771-10.667 10.667V160c0 5.896 4.771 10.667 10.667 10.667h42.279L255.72 333.966 32.286 130.781c-4.357-3.961-11.111-3.655-15.089.682L2.794 147.171c-3.978 4.339-3.672 11.068.685 15.03l237.773 216.231c4.078 3.72 9.241 5.569 14.405 5.569 5.131 0 10.263-1.829 14.331-5.506l199.345-179.639v46.479c0 5.896 4.771 10.667 10.667 10.667h21.333c5.896 0 10.667-4.771 10.667-10.667V138.667c0-5.896-4.771-10.667-10.667-10.667z"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgBounce, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/bounce.4d4d3fa4.svg";
export { ForwardRef as ReactComponent };